module.exports = __webpack_public_path__ + "static/04-9ba2709f39b35a9fcc6b2f336061c163.jpg";